import { cn } from '@/utils/cn';
import React from 'react';

const ModalConfirmButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<'button'> & { children?: React.ReactNode }
>(({ className, children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        'px-[12px] py-[8px] bg-[#0C8DBF] text-white rounded-[8px] hover:bg-[#0C8DBF]/80 transition-colors cursor-pointer text-[14px] font-[600] disabled:cursor-not-allowed disabled:bg-[#0C8DBF]/50 disabled:border-[#0C8DBF] disabled:text-[#FFF] flex items-center justify-center gap-[8px]',
        className
      )}
      {...props}
    >
      {children || 'Confirm'}
    </button>
  );
});
ModalConfirmButton.displayName = 'ModalConfirmButton';

export { ModalConfirmButton };
